<template>
  <div>
    <transition name="fade">
      <div
        v-show="isShownVisualizationPanel"
        class="layer-mask"
        @click="hideVisualizationPanel"
      />
    </transition>
    <transition name="lift">
      <section
        v-show="isShownVisualizationPanel"
        class="layer-contents"
      >
        <img
          class="layer-contents-close-button"
          src="~@/assets/images/close_button.svg"
          @click="hideVisualizationPanel"
        >

        <v-ons-row
          class="layers"
          vertical-align="center"
        >
          <v-ons-col
            v-for="visualizationLayer in visualizationLayers"
            :key="visualizationLayer.value"
            :class="['layer', { current : isCurrent(visualizationLayer.value) }]"
            @click="switchVisualizationLayerType(visualizationLayer.value)"
          >
            <div class="layer-title">{{ visualizationLayer.name }}</div>
            <div class="layer-panel">
              <img :src="visualizationLayer.image">
            </div>
          </v-ons-col>
        </v-ons-row>

      </section>
    </transition>
  </div>
</template>

<script>
import config from '@/config.js';

export default {
  computed: {
    visualizationLayers: () => config.visualizationLayers,
    visualizationLayerType: ({ $store }) => $store.state.map.visualizationLayerType,
    isCurrent: ({ visualizationLayerType }) => (value) => value === visualizationLayerType,
    isShownVisualizationPanel: {
      get: ({ $store }) => $store.state.map.isShownVisualizationPanel,
      set(value) {
        this.$store.commit('map/toggleVisualizationPanel', value);
      },
    },
  },
  methods: {
    switchVisualizationLayerType(value) {
      this.$store.commit('map/setVisualizationLayerType', value);
    },
    hideVisualizationPanel() {
      this.isShownVisualizationPanel = false;
    },
  },
};
</script>

<style scoped lang="scss">
.layer-mask {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 400;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.layer-contents {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 401;
  width: 100%;
  background: #fff;
  &-header {
    align-items: center;
  }
  &-title {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    padding: 0 20px;
    width: auto;
    height: 55px;
    h1 {
      font-size: inherit;
    }
  }
  &-tab {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    width: auto;
    margin-right: 10px;
    /deep/ .button {
      width: 4em;
      text-align: center;
    }
  }
  &-close-button {
    position: absolute;
    top: 64px;
    left: 80px;
    z-index: 10;
  }
}
.layers {
  position: relative;
  justify-content: center;
  height: 208px;
  line-height: 1em;
  @media (max-width: 767px) {
    justify-content: space-between;
    margin: 0 auto;
    height: calc((15vw + 3em) * 2);
    max-height: none;
    width: calc((29.3vw) * 3);
  }
}
.layer {
  display: flex;
  flex-direction: column-reverse;
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  width: 160px;
  text-align: center;
  @media (max-width: 767px) {
    flex: 0 0 29.3vw;
  }

  &[disabled] {
    pointer-events: none;
    opacity: 0.2;
  }
  &-title {
    @media (max-width: 413px) {
      font-size: 13px;
    }
  }
  &-panel {
    overflow: hidden;
    position: relative;
    display: inline-block;
    margin: 0 10px 0.5em;
    width: 15vw;
    height: 15vw;
    max-width: 100px;
    max-height: 100px;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      box-sizing: border-box;
      border: 2px solid transparent;
      border-radius: 7.5%;
      width: 100%;
      height: 100%;
      pointer-events: none;
    }
    img {
      width: 100%;
    }
  }
  &.current {
    font-weight: bold;
    color: #0274bf;
  }
  &.current &-panel:before {
    border-color: #0274bf;
  }
}

.fade {
  &-enter-active, &-leave-active {
    transition: opacity .5s;
  }
  &-enter, &-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
.lift {
  &-enter-active, &-leave-active {
    transition: transform .5s;
  }
  &-enter-to, &-leave {
    transform: translate(0, 0%) !important;
  }
  &-enter, &-leave-to {
    transform: translate(0, 100%) !important;
  }
}
</style>



// WEBPACK FOOTER //
// panel.vue?a1054678